export const GET_ALL_COURSES = 'GET_ALL_COURSES'
export const GET_SLIDER_COURSES = 'GET_SLIDER_COURSES'
export const GET_COURSE = 'GET_COURSE'
export const TOGGLE_STATE = 'TOGGLE_STATE'
export const ERROR_STATE = 'ERROR_STATE'
